module.exports = __webpack_public_path__ + "yeni çalışma masası.jpg?85072f0987876d7b9de1fd1e0f026766";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni çalışma masası.jpg
// module id = 389
// module chunks = 0